import http from '@/libs/http'

/**
 * 获取列表
 * */
export const getOrderRateList = (orderId,
                                 userId,
                                 clerkId,
                                 content,
                                 isAnonymous,
                                 isAuto,
                                 isShow,
                                 createdStart,
                                 createdEnd,
                                 pageNo,
                                 pageSize) => {
  return http.request({
    url: '/s/kf/order/rate/list',
    params: {
      orderId,
      userId,
      clerkId,
      content,
      isAnonymous,
      isAuto,
      isShow,
      createdStart,
      createdEnd,
      pageNo,
      pageSize
    },
    method: 'get'
  })
}
